import { ChangeDetectorRef, Component, Injector } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LayoutAuthSettingsShared } from 'src/app/components/shared/models/interface/layoutAuthSettings.interface';
import { sharedAuthConstants } from 'src/app/components/shared/sharedConstants/auth.constants';
import { MuDeliveryService } from 'src/app/components/shared/sharedProtos/delivery/mu-delivery.service';
import { MuCookieService } from 'src/app/components/shared/sharedServices/mu-cookie.service';
import { UserDataService } from 'src/app/components/shared/sharedServices/user-data.service';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { LayoutAuthService } from './layout-auth.service';

@Component({
  selector: 'app-layout-auth',
  templateUrl: './layout-auth.component.html',
  styleUrls: ['./layout-auth.component.sass'],
})
export class LayoutAuthComponent extends MuComponent {
  indexTabs = {
    login: 0,
    signup: 1,
    recover: 2,
  };
  settings: LayoutAuthSettingsShared<any>;
  tab: number;
  routerSub: Subscription;
  firstEntry = true;

  private layoutAuthService: LayoutAuthService<any>;
  private muDeliveryService: MuDeliveryService;
  private muCookieService: MuCookieService;
  private userDataService: UserDataService;
  private router: Router;
  private route: ActivatedRoute;
  private changeDetectorRef: ChangeDetectorRef;

  constructor(private injector: Injector) {
    super();
    this.layoutAuthService = this.injector.get<LayoutAuthService<any>>(LayoutAuthService);
    this.muDeliveryService = this.injector.get<MuDeliveryService>(MuDeliveryService);
    this.muCookieService = this.injector.get<MuCookieService>(MuCookieService);
    this.userDataService = this.injector.get<UserDataService>(UserDataService);
    this.router = this.injector.get<Router>(Router);
    this.route = this.injector.get<ActivatedRoute>(ActivatedRoute);
    this.changeDetectorRef = this.injector.get<ChangeDetectorRef>(ChangeDetectorRef);
  }

  async muOnInit(): Promise<void> {
    this.checkActualRouteTab();
    this.watch(this.layoutAuthService.settings).subscribe((settings: LayoutAuthSettingsShared<any>) => {
      this.settings = settings;
      this.changeDetectorRef.detectChanges();
    });
    await this.getAuthToken();
  }

  muOnDestroy(): void {
    this.routerSub.unsubscribe();
  }

  /**
   * method to generate token
   *
   * @private
   * @memberof LayoutComponent.getAuthToken
   */
  private async getAuthToken() {
    const oAuthToken = await this.muDeliveryService.getDefaultOauthToken();
    const expire = oAuthToken.expirationtime;
    this.userDataService.setTokenLocal(oAuthToken.accesstoken);
    this.muCookieService.setCookie('token-mu', oAuthToken.accesstoken, expire);
    this.muCookieService.setCookie('token-expires-in', oAuthToken.expirationtime.toString(), expire);
    this.muCookieService.setCookie('token-refresh-token', oAuthToken.refreshtoken, expire);
    this.muCookieService.setCookie('token-token-type', oAuthToken.tokentype, expire);
  }

  /**
   * changeTab
   * @param {number} tabIndex
   */
  changeTab(tabIndex: number): void {
    switch (tabIndex) {
      case this.indexTabs.login:
        if (this.firstEntry && this.tab === this.indexTabs.recover) {
          this.firstEntry = false;
          this.router.navigate(['']);
        } else {
          this.router.navigate(['/page/login']);
        }
        break;
      case this.indexTabs.signup:
        this.router.navigate(['/crear-cuenta']);
        break;
      case this.indexTabs.recover:
        this.router.navigate(['/page/recover']);
        break;
    }
    this.tab = tabIndex;
  }

  /**
   * set indexTab using actual Routing
   */
  checkActualRouteTab(): void {
    this.routerSub = this.router.events.subscribe(nav => {
      if (nav instanceof NavigationEnd) {
        switch (nav.url) {
          case sharedAuthConstants.url.login:
            this.changeTab(this.indexTabs.login);
            break;
          case sharedAuthConstants.url.signUp:
            this.changeTab(this.indexTabs.signup);
            break;
          case sharedAuthConstants.url.signUpVerify:
            this.tab = this.indexTabs.signup;
            break;
          case sharedAuthConstants.url.signUpData:
            this.tab = this.indexTabs.signup;
            break;
          case sharedAuthConstants.url.signUpPerson:
            this.tab = this.indexTabs.signup;
            break;
          case sharedAuthConstants.url.signUpCompany:
            this.tab = this.indexTabs.signup;
            break;
          case sharedAuthConstants.url.recover:
            this.changeTab(this.indexTabs.recover);
            break;
        }
      }
    });

    if (this.firstEntry) {
      if (this.router.routerState.snapshot.url.toString().includes(sharedAuthConstants.url.autoLogin)) {
        this.tab = this.indexTabs.login;
      }      
      switch (this.excludeUrlParameters(this.router.routerState.snapshot.url, ('?'))) {
        case sharedAuthConstants.url.login:
        case '/page/login/auto/1':
          this.tab = this.indexTabs.login;
          break;
        case sharedAuthConstants.url.signUp:
        case sharedAuthConstants.url.signUpVerify:
        case sharedAuthConstants.url.signUpData:
        case sharedAuthConstants.url.signUpPerson:
        case sharedAuthConstants.url.signUpCompany:
          this.tab = this.indexTabs.signup;
          break;
        case sharedAuthConstants.url.recover:
          this.tab = this.indexTabs.recover;
          break;
        case '/auto-verificacion/crear-cuenta':
          this.tab = this.indexTabs.signup;
          break;
      }
// eslint-disable-next-line @typescript-eslint/dot-notation
      // eslint-disable-next-line @typescript-eslint/dot-notation
      if (this.route.snapshot.queryParams['nonce']) {
        this.tab = this.indexTabs.recover;
      }
    }
  }

  /**
   * 
   * @param url 
   * @param separator 
   * @returns An url without parameter acording to the given separator.
   */
  excludeUrlParameters(url: string, separator: string): string{
    return url.split(separator)[0];
  }
}
